import DuoFunnelLayout from '@/components/v2/DuoFunnelLayout'
import DuoMascotPrompt from '@/components/v2/DuoMascotPrompt'
import { useTranslation } from 'react-i18next'
import { Form } from 'react-router-dom'
import type { DuoBenefit, StepScreenProps } from './types'

/**
 * Duolingo's "Here's what you can achieve!" beat: the mascot says the line and
 * three benefit rows sit underneath, separated by hairlines. It is a statement,
 * not a question, so it tracks like the mascot beats do.
 */
export default function AchievementsStep({
  benefits,
  interpolation,
  step,
  titleKey,
  totalSteps,
}: StepScreenProps & {
  benefits: DuoBenefit[]
  titleKey: string
}) {
  const { t } = useTranslation()

  return (
    <Form method="post">
      <DuoFunnelLayout
        footer={
          <button
            className="duo-button-primary"
            data-testid="button-continue"
            type="submit"
          >
            {t('shared.continue')}
          </button>
        }
        step={step}
        totalSteps={totalSteps}
      >
        <input
          name={t(titleKey, { lng: 'en', ...interpolation })}
          type="hidden"
          value={t('shared.continue', { lng: 'en' })}
        />

        <DuoMascotPrompt text={t(titleKey, interpolation)} />

        <div className="divide-duo-line mt-10 flex grow flex-col divide-y px-2">
          {benefits.map((benefit) => (
            <div
              className="flex items-start gap-4 py-6 first:pt-0"
              key={benefit.titleKey}
            >
              <span aria-hidden="true" className="text-3xl leading-none">
                {benefit.emoji}
              </span>

              <div className="space-y-1">
                <p className="text-duo-ink text-base font-extrabold">
                  {t(benefit.titleKey, interpolation)}
                </p>

                <p className="text-duo-muted text-[15px] leading-relaxed">
                  {t(benefit.bodyKey, interpolation)}
                </p>
              </div>
            </div>
          ))}
        </div>
      </DuoFunnelLayout>
    </Form>
  )
}
